import { render } from "./OpeningHoursPeriodsOverview.vue?vue&type=template&id=5ba56f30&scoped=true&ts=true"
import script from "./OpeningHoursPeriodsOverview.vue?vue&type=script&lang=ts"
export * from "./OpeningHoursPeriodsOverview.vue?vue&type=script&lang=ts"

import "./OpeningHoursPeriodsOverview.vue?vue&type=style&index=0&id=5ba56f30&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba56f30"]])

export default __exports__